import { render, staticRenderFns } from "./ReportingCardStats.vue?vue&type=template&id=b0ef5d06&scoped=true"
import script from "./ReportingCardStats.vue?vue&type=script&lang=js"
export * from "./ReportingCardStats.vue?vue&type=script&lang=js"
import style0 from "./ReportingCardStats.vue?vue&type=style&index=0&id=b0ef5d06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ef5d06",
  null
  
)

export default component.exports